import { ADMIN_QUERIES } from 'constants/params';
import { PROJECT_BASENAME } from 'constants/env';
import { isDev } from './env';

export const isPaymentFlow = () =>
  window.location.href.includes('/payment-flow');

export const isAdminPage = () => window.location.href.includes(ADMIN_QUERIES.AGENT_STAFF);

export const setLoginRedirect = (path, withLogged = false, isLogged = false, getUrl = false, isComplete = false) => {
  if (isDev()) return;

  const url = isComplete ? path : `${PROJECT_BASENAME}${path}`;
  const origin = isComplete ? '' : window.location.origin;
  const redirectTo = withLogged && isLogged ? url
    // : `/Mesa-de-Regalos/before-guest?redirect=${origin}${url}`;
    : `/Mesa-de-Regalos/login?redirect=${origin}${url}`;
  if (getUrl) {
    return redirectTo;
  }
  //  console.log("redirectTo a portal",redirectTo);
  window.location.href = redirectTo;
};

export const setLoginRedirectGuest = (path, withLogged = false, isLogged = false, getUrl = false, isComplete = false) => {
  if (isDev()) return;

  const url = isComplete ? path : `${PROJECT_BASENAME}${path}`;
  const origin = isComplete ? '' : window.location.origin;
  const redirectTo = withLogged && isLogged ? url
    : `/guest?redirect=${origin}${url}`;
  if (getUrl) {
    return redirectTo;
  }
  //  console.log("redirect to: ",redirectTo);
  window.location.href = redirectTo;
};

export const setLoginRedirectSSO = (path, withLogged = false, isLogged = false, getUrl = false, isComplete = false) => {
  if (isDev()) return;

  const url = isComplete ? path : `${PROJECT_BASENAME}${path}`;
  const origin = isComplete ? '' : window.location.origin;
  const redirectTo = withLogged && isLogged ? url
    : `/Mesa-de-Regalos/login?redirect=${origin}${url}`;
  if (getUrl) {
    return redirectTo;
  }
  //  console.log("redirectTo a portal",redirectTo);
  window.location.href = redirectTo;
};